import React from 'react';
import { connect } from 'react-redux';

import { fetchShippingEstimate } from 'actions/shippings';
import {
  getShippingPrice,
  getShippingPriceStatus,
  getShippingPriceError,
} from 'reducers';
import ShippingEstimateForm from 'components/ShippingEstimateForm';
import ShippingInvoice from 'components/ShippingInvoice';
import Spinner from 'components/Spinner';

const ShippingEstimate = ({
  fetchShippingEstimate,
  shippingEstimate,
  errorMsg,
  shippingQueryStatus: { pending },
}) => (
  <section>
    <h1>Shipping Estimate</h1>
    <br />
    <ShippingEstimateForm
      onSubmit={fetchShippingEstimate}
      errorMsg={errorMsg}
    />
    <br />
    <ShippingInvoice shippingEstimate={shippingEstimate} />
    <Spinner showLoader={pending} />
  </section>
);

const mapStateToProps = (state) => ({
  shippingEstimate: getShippingPrice(state),
  shippingQueryStatus: getShippingPriceStatus(state),
  errorMsg: getShippingPriceError(state),
});

const mapDispatchToProps = {
  fetchShippingEstimate,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShippingEstimate);
